import { jsx as _jsx } from "react/jsx-runtime";
import { hydrateRoot } from 'react-dom/client';
import Router from './router';
import './assets';
const MOUNT_POINT = document.getElementById('app');
hydrateRoot(MOUNT_POINT, _jsx(Router, {}));
